import uuidv4 from "uuid/v4";

export default class LessorComponentShares {
  constructor(
    idInDB,
    externalId,
    lessorId,
    startDate,
    endDate,
    paymentsParameters,
    manualChartPayments,
  ) {
    this.idInDB = idInDB;
    this.externalId = externalId;
    this.lessorId = lessorId;
    this.startDate = startDate;
    this.endDate = endDate;
    this.paymentsParameters = paymentsParameters;
    this.manualChartPayments = manualChartPayments;
  }

  static createFromData(data) {
    return new LessorComponentShares(
      data.idInDB,
      data.externalId,
      data.lessorId,
      data.startDate,
      data.endDate,
      data.paymentsParameters,
      data.manualChartPayments,
    )
  }

  static createNew(lessorId, startDate = null, endDate = null) {
    const uuidv4 = require('uuid/v4');
    return new LessorComponentShares(
      uuidv4(),
      null,
      lessorId,
      startDate,
      endDate,
      [],
      [],
    );
  }
}
